/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const LightningBoltBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="m10.271 3.849-2.956 9.244h2.541c.672 0 1.205.517 1.163 1.13l-.274 4.001 5.421-6.98h-1.861c-.841 0-1.405-.787-1.068-1.49L16.07 3.85H10.27ZM8.506 2.765C8.651 2.312 9.107 2 9.626 2h7.761c.84 0 1.405.787 1.068 1.49l-2.833 5.905h2.21c.946 0 1.498.974.951 1.678l-8.136 10.476c-.678.873-2.187.388-2.114-.681l.406-5.926H6.166c-.777 0-1.336-.68-1.119-1.361l3.46-10.816Z" /></svg>);
const LightningBolt = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={LightningBoltBase} {...rest} ref={ref} />);
export default LightningBolt;